export const PAGINATION_LIMIT_DEFAULT = 10;
